import {Checkbox, Group, Stack, Text} from '@mantine/core';
import React from 'react';

import FieldLabel from 'ui-library/inputs/FieldLabel';

export interface RowOnlyConfig {
  showSubmissionSetting: boolean;
  rowOnlyInitialValue?: boolean;
}
interface RowByRowSubmissionSettingProps {
  locked: boolean;
  rowByRowSubmissionRequired: boolean;
  onRowByRowSubmissionRequiredChange: (rowByRowSubmissionRequired: boolean) => void;
}

const CHECKBOX_ID = 'row-by-row-submission-checkbox';

export default function RowByRowSubmissionSetting(props: RowByRowSubmissionSettingProps): JSX.Element {
  return (
    <Group align="flex-start" noWrap={true} spacing="sm" w="100%">
      <Checkbox
        checked={props.rowByRowSubmissionRequired}
        disabled={props.locked}
        id={CHECKBOX_ID}
        size="md"
        styles={{inner: {alignSelf: 'flex-start'}}}
        onChange={(event) => {
          props.onRowByRowSubmissionRequiredChange(event.currentTarget.checked);
        }}
      />
      <Stack spacing={4}>
        <FieldLabel htmlFor={CHECKBOX_ID} label="Require rows to be submitted one at a time" />
        <Text color="dimmed" size="sm">
          The audit log records the author of each row as the person who submits it
        </Text>
      </Stack>
    </Group>
  );
}
